import type { Editor } from '@tiptap/core'
import { Extension } from '@tiptap/core'
import { DEFAULT_LINE_HEIGHT } from '@/constants/'
import type { GeneralOptions } from '@/notebook/type'
import { createLineHeightCommand } from '@/notebook/utils/line-height'
import LineHeightDropdown from './components/LineHeightDropdown.vue'

export type LineHeightOptions = {
  types: string[]
  lineHeights: string[]
  defaultHeight: string
} & GeneralOptions<LineHeightOptions>

declare module '@tiptap/core' {
  type Commands<ReturnType> = {
    lineHeight: {
      setLineHeight: (lineHeight: string) => ReturnType
      unsetLineHeight: () => ReturnType
    }
  }
}

export const LineHeight = Extension.create<LineHeightOptions>({
  name: 'lineHeight',
  addOptions() {
    return {
      ...this.parent?.(),
      types: ['paragraph', 'heading', 'list_item', 'todo_item'],
      lineHeights: ['100%', '115%', '150%', '200%', '250%', '300%'],
      defaultHeight: DEFAULT_LINE_HEIGHT,
      button({ editor, t }: { editor: Editor; t: any }) {
        return {
          component: LineHeightDropdown,
          componentProps: {
            editor,
            icon: 'LineHeight',
            tooltip: t('editor.lineheight.tooltip'),
          },
        }
      },
    }
  },

  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (element) => {
              return element.style.lineHeight || this.options.defaultHeight
            },
            renderHTML: (attributes) => {
              if (attributes.lineHeight === this.options.defaultHeight || !attributes.lineHeight) {
                return {}
              }

              return { style: `line-height: ${attributes.lineHeight}` }
            },
          },
        },
      },
    ]
  },

  addCommands() {
    return {
      setLineHeight: (lineHeight) => createLineHeightCommand(lineHeight),
      unsetLineHeight:
        () =>
        ({ commands }) => {
          return this.options.types.every((type) => commands.resetAttributes(type, 'lineHeight'))
        },
    }
  },
})
